export default {"src":"/_next/static/media/productsList.ce334b29.svg","height":122,"width":35,"blurWidth":0,"blurHeight":0};